import { ProductCurriculum } from 'types/schema-generated-types';

const PRMS_SET_A_CURRICULUM_CODE = 'PRMS-A';

const isPrmSetACurriculum = (productCurriculum?: ProductCurriculum | null): boolean =>
  productCurriculum?.code === PRMS_SET_A_CURRICULUM_CODE;

export { isPrmSetACurriculum };
